import type { ComponentType } from "react";
import {
  useLocation,
  useNavigate,
  type RegisteredRouter,
  type RouterState,
  type UseNavigateResult,
} from "@tanstack/react-router";

interface RouterProps {
  navigate: UseNavigateResult<string>;
  location: RouterState<RegisteredRouter["routeTree"]>["location"];
}

/** For class components, which can't call hooks: passes the router's `navigate` and the current `location` as props. */
export function withRouter<P extends RouterProps>(Component: ComponentType<P>) {
  return function WithRouter(props: Omit<P, keyof RouterProps>) {
    const navigate = useNavigate();
    const location = useLocation();
    // TypeScript can't see that `Omit<P, keyof RouterProps>` plus the router props is `P` for a generic `P`.
    return <Component {...(props as P)} navigate={navigate} location={location} />;
  };
}
